import React from 'react'
import { useFormContext } from 'react-hook-form'
import { components } from 'react-select'

import { Select, TextInput } from '@/components/uikit'

import { usePlaceAutocomplete } from './hooks'

import type { PlaceAutocompleteSelectProps } from './types'
import type { ReactElement } from 'react'

const Input = (props) => <components.Input {...props} isHidden={false} />

export const PlaceAutocomplete = <TFormFields,>({
  onChange,
  placeholder = 'Start typing something',
  value,
  name,
  label,
  disabled,
  rules,
  dataCy,
  initialInputValue,
  onlyStreetValue,
  officeSuggestions,
  additionalExtraComponents = {},
  ...restProps
}: PlaceAutocompleteSelectProps<TFormFields>): ReactElement => {
  const { options, onChangeHandler, onSearch, inputValue, isLoading } =
    usePlaceAutocomplete({
      value,
      onChange,
      initialInputValue,
      onlyStreetValue,
      officeSuggestions,
    })
  const { register } = useFormContext<TFormFields>()

  return disabled ? (
    <TextInput
      {...register(name, {
        required: rules?.required,
      })}
      label={label}
      placeholder={placeholder as string}
      readOnly
      data-cy={dataCy}
    />
  ) : (
    <Select<TFormFields, string>
      name={name}
      label={label}
      rules={rules}
      disabled={disabled || isLoading}
      dataCy={dataCy}
      placeholder={placeholder}
      onChange={onChangeHandler}
      onInputChange={onSearch}
      options={options}
      inputValue={inputValue}
      extraComponents={{
        Input,
        ...additionalExtraComponents,
      }}
      {...restProps}
    />
  )
}
